export const MOBILE_BOOKING_FORM_VALUE = "mbl_booking";

export function getMobileBookingLocationId(
  locations?: { id: string; name?: string }[]
): string | undefined {
  return locations?.find((location) => location.name === "Mobile Booking")?.id;
}

export function resolveOnlineBookingLocationId(
  selectedLocation: string | undefined,
  storedLocationId: string | null | undefined,
  locations?: { id: string; name?: string }[]
): string | undefined {
  if (selectedLocation === MOBILE_BOOKING_FORM_VALUE) {
    return getMobileBookingLocationId(locations);
  }
  return storedLocationId || undefined;
}

export function resolveSubmitTimezone(
  selectedLocation: string | undefined,
  formTimezone?: string | null,
  addressTimezone?: string | null
): string | null {
  if (selectedLocation === MOBILE_BOOKING_FORM_VALUE) {
    return addressTimezone || formTimezone || null;
  }
  return formTimezone || null;
}
